/* eslint-disable no-console */
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { useClientWebResolver } from '@cp/entities/clientWebRoutes';
import { useRouter } from '@cp/shared/router';
import { useCallback } from 'react';

export const useNavigateToDialog = (namespace: string) => {
  const router = useRouter();
  const resolver = useClientWebResolver();
  return useCallback(
    (dialogId: number) => {
      () => {
        console.debug(`[${namespace}]: Redirecting to the dialog page...`);
        return router.navigate(resolver.resolve({ page: ClientWebPage.ProfileMessages, queryParams: { dialogId } }));
      };
    },
    [namespace, router, resolver],
  );
};
